export const TeamState = {
	BasicDetails: 1,
	Roles: 2,
	People: 4,
	Billing: 8,
	Settings: 16,
	
	Complete: 1 | 2 | 4 | 8 | 16
}